<template>
  <master-page>
    <br/>
    <v-card>
      <v-card-title>
        <v-icon large left>mdi-format-list-numbered-rtl</v-icon>
        <span class="title font-weight-light">Movimentação Bancária</span>
        <v-spacer/>
          <v-tooltip bottom v-if=" tipoUsuario == 'GESTOR' ? UsuarioRestrito(['G','P','E']) : UsuarioRestrito(['G','P','E']) || !PermissaoRestrita('LancamentoBancario2')">
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Transferir()">
                  <v-icon>mdi-bank-transfer</v-icon>
              </v-btn>
            </template>
            <span>Transferência Bancária</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn icon color="blue-grey lighten-1" class="mb-2" dark v-on="on">
                <v-icon>mdi-bank-transfer</v-icon>
              </v-btn>
            </template>
            <span>Transferência Bancária</span> <br/>
            <span>Restrito ao seu usuário ou plano.</span>
          </v-tooltip>
          <v-tooltip bottom v-if="tipoUsuario == 'GESTOR' ? false : PermissaoRestrita('LancamentoBancario2')">
            <template v-slot:activator="{ on }">
              <v-btn icon color="blue-grey lighten-1" class="mb-2" dark v-on="on">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Novo Lançamento Bancário</span> <br/>
            <span>Restrito ao seu usuário ou plano.</span>
          </v-tooltip>
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Novo()">
                  <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Novo Lançamento Bancário</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Novo()">
                  <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Novo Lançamento Bancário</span>
          </v-tooltip> -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" class="mb-2" dark v-on="on" @click="Listar()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>Atualizar</span>
          </v-tooltip>

          <v-expansion-panels focusable v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-header>Filtros</v-expansion-panel-header>
                <v-expansion-panel-content class="mt-5">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete v-model="filtro.bancoId" :items="bancos" item-text="codigoNome" item-value="id" label="Banco" placeholder="Selecione um banco" dense outlined/>
                      <!-- <v-select v-model="filtro.bancoId" label="Banco" :items="bancos" item-value="id" item-text="nome" dense outlined/> -->
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select v-model="filtro.tipo" label="Situação" :items="tipos" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="6" v-if="filtro.bancoId == null">
                      <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                        <template v-slot:activator="{on}">
                          <v-text-field type="month" v-model="filtro.dataReferencia" label="Mês/Ano Referência" :rules="fieldRules" dense outlined>
                            <template v-slot:prepend>
                              <v-icon v-on="on">mdi-calendar</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker locale="pt-br" type="month" v-model="filtro.dataReferencia" no-title/>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="2" v-if="filtro.bancoId != null">
                      <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                        <template v-slot:activator="{on}">
                          <v-text-field type="date" v-model="filtro.dataInicial" label="Data Inicial" :rules="fieldRules" dense outlined>
                            <template v-slot:prepend>
                              <v-icon v-on="on">mdi-calendar</v-icon>
                            </template>
                          </v-text-field>
                        </template>
                        <v-date-picker locale="pt-br" v-model="filtro.dataInicial" no-title/>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="1" v-if="filtro.bancoId != null">
                      <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                    </v-col>
                    <v-col cols="12" md="2" v-if="filtro.bancoId != null">
                      <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                          <template v-slot:activator="{on}">
                            <v-text-field type="date" v-model="filtro.dataFinal" label="Data Final" :rules="fieldRules" prepend-icon="mdi-calendar" dense outlined>
                              <template v-slot:prepend>
                                <v-icon v-on="on">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker locale="pt-br" v-model="filtro.dataFinal" no-title/>
                      </v-menu>
                    </v-col>
                    <v-spacer/>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="filtro.codigoInicio" label="Código (Inicio)" dense outlined/>
                    </v-col>
                    <v-col cols="12" md="1">
                      <span style="font-size: 18px; display: flex; justify-content: center; align-items: center">até</span>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-text-field v-model="filtro.codigoFim" label="Código (Fim)" dense outlined/>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete v-model="filtro.doadorId" :items="doadores" :loading="isLoading" :search-input.sync="searchDoador" hide-no-data hide-selected cache-items clearable
                        item-text="cpfCnpjNome" item-value="id" label="Doador" placeholder="Digite um doador" dense outlined>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-autocomplete v-model="filtro.fornecedorId" :items="fornecedores" :loading="isLoading" :search-input.sync="searchFornecedor" hide-no-data hide-selected cache-items clearable
                        item-text="cpfCnpjNome" item-value="id" label="Fornecedor" placeholder="Digite um fornecedor" dense outlined>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-spacer/>
                    <v-btn color="accent" @click="Listar()">Consultar</v-btn>
                  </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
      </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <b>Saldo Inicial: {{ extrato ? extrato.saldoInicial.toMoeda(true) : 0 }}</b>
                </v-col>
                <v-col cols="12" md="3">
                  <b>Saídas: {{ extrato ? extrato.totalSaida.toMoeda(true) : 0 }}</b>
                </v-col>
                <v-col cols="12" md="3">
                  <b>Entradas: {{ extrato ? extrato.totalEntrada.toMoeda(true) : 0 }}</b>
                </v-col>
                <v-col cols="12" md="3">
                  <b>Saldo Atual: {{ extrato ? extrato.saldoAtual.toMoeda(true) : 0 }}</b>
                </v-col>
              </v-row>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left"></th>
                      <th class="text-left">Código</th>
                      <th class="text-left">Banco</th>
                      <th class="text-left">Data</th>
                      <th class="text-left">Descrição</th>
                      <th class="text-left">Cheque</th>
                      <th class="text-left">Entrada</th>
                      <th class="text-left">Saída</th>
                    </tr>
                  </thead>
                  <tbody v-if="extrato">
                    <tr v-for="item in extrato.items" :key="item.id">
                      <td class="justify-center layout px-0">
                        <v-tooltip right v-if="item.avulso">
                          <template v-slot:activator="{ on }">
                            <v-icon small @click="Editar(item)" v-on="on">mdi-pencil</v-icon>
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                      <v-tooltip right v-if="item.avulso || (item.idPlanoContas === 0 && item.idPlanoContas_Item === 0 && item.idTransferencia > 0)">
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Excluir(item)" v-on="on">mdi-delete</v-icon>
                        </template>
                        <span>Excluir</span>
                      </v-tooltip>
                      <v-tooltip right v-if="item.idCompromisso || item.idFinanceiro">
                        <template v-slot:activator="{ on }">
                          <v-icon small @click="Reabrir(item)" v-on="on">mdi-lock-open</v-icon>
                        </template>
                        <span>Reabrir</span>
                      </v-tooltip>
                      </td>
                      <td>{{ item.idFluxoBancario }}</td>
                      <td>{{ item.banco }}</td>
                      <td>{{ new Date(item.data).ddmmyyyy() }}</td>
                      <td>{{ item.descricao }}</td>
                      <td>{{ item.numeroCheque }}</td>
                      <td>{{ item.credito.toMoeda() }}</td>
                      <td>{{ item.debito.toMoeda() }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
        </v-card>

    <cadastro-fluxobancario v-model="dialogCadastro" :item="item" @fechou="dialogCadastro = false" @salvou="Listar()"/>
    <transferencia-bancaria v-model="dialogTransferencia" :item="transferencia" @fechou="dialogTransferencia = false" @salvou="Listar()"/>

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </master-page>
</template>

<script>
import FluxoBancarioService from '@/core/services/financeiro/FluxoBancarioService';
import TipoFluxoBancarioEnumService from '@/core/services/financeiro/TipoFluxoBancarioEnumService';
import FluxoBancario from '@/core/domain/financeiro/FluxoBancario';
import Transferencia from '@/core/domain/financeiro/Transferencia';
import BancoService from '@/core/services/financeiro/BancoService';
import DoadorService from '@/core/services/doacao/DoadorService';
import FornecedorService from '@/core/services/financeiro/FornecedorService';
import { EmpresaService } from '../../../core/services/geral';
import Empresa from '../../../core/domain/geral/Empresa'
import UsuarioService from '../../../core/services/geral/UsuarioService';

export default {
  data() {
    return {
      service: new FluxoBancarioService(),
      empresaService: new EmpresaService(),
      item: new FluxoBancario(),
      empresa: new Empresa(),
      transferencia: new Transferencia(),
      extrato: null,
      dialogCadastro: false,
      dialogTransferencia: false,
      fieldRules: [
        v => !!v || 'Campo obrigatório'
      ],
      searchDoador: null,
      searchFornecedor: null,
      isLoading: false,
      filtro: {
        bancoId: null,
        tipo: "",
        dataInicial: new Date().yyyymmdd(),
        dataFinal: new Date().yyyymmdd(),
        fornecedorId: null,
        doadorId: null,
        codigoInicio: null,
        codigoFim: null,
        dataReferencia: new Date().yyyymm()
      },
      panel: 0,
      bancos: [],
      tipos: [],
      doadores: [],
      fornecedores: [],
      empresaPlano: '',
      sessionApp: '',
      permissoes: [],
      tipoUsuario: ''
    }
  },
  watch: { 
    searchDoador (val) {
      if (this.isLoading) return;
      if (!val) return;
      if (val.length < 3 ) return;
      
      this.isLoading = true
      let doadorService = new DoadorService();
      doadorService.AutoComplete(val).then(
        res => {
          this.doadores = res.data;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      ).finally(() => {
        this.isLoading = false
      })
    },
    searchFornecedor (val) {
      if (this.isLoading) return;
      if (!val) return;
      // if (val.length < 3 ) return;
      
      this.isLoading = true
      let fornecedorService = new FornecedorService();
      fornecedorService.AutoComplete(val).then(
        res => {
          this.fornecedores = res.data;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      ).finally(() => {
        this.isLoading = false
      })
    },
    'filtro.dataReferencia': {
      handler: function (val) {
        this.MesReferencia();
      },
      deep: true
    }
  },
  methods: {
    MesReferencia(){
      var hoje = new Date(this.filtro.dataReferencia);
      this.filtro.dataInicial = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 1).yyyymmdd();
      this.filtro.dataFinal = new Date(hoje.getFullYear(), hoje.getMonth() + 2, 0).yyyymmdd();
    },
    Transferir(){
      this.dialogTransferencia = true;
    },     
    Novo(){
      this.item = new FluxoBancario()
      this.dialogCadastro = true;
    },
    Editar(item){
      this.service.ObterPorId(item.idFluxoBancario).then(
        res =>{
          this.item = Object.assign({}, new FluxoBancario(res.data));
          this.dialogCadastro = true;
        },
        err => this.$swal('Aviso', err.response.data, 'error')
      )
    },
    Reabrir(item){
      this.$swal({
        title: 'Atenção!',
        text: 'Tem certeza que deseja Reabrir o registro atual?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.service.Reabrir(item.idFluxoBancario).then(
            res => {
              if (res.status == 200){
                return res;
              }
            }, 
            err => this.$swal('Aviso', err.response.data, 'error')
          )
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if(result.value) {
          this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
          this.Listar();
        }
      })
    },
    Excluir(item) {
      this.$swal({
        title: 'Atenção!',
        text: 'Tem certeza que deseja excluir o registro atual?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.service.Excluir(item.idFluxoBancario)
          .then(
            res => {
              if (res.status == 200){
                return res;
              }
            }, 
            err => this.$swal('Aviso', err.response.data, 'error')
          )
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then((result) => {
        if(result.value) {
          this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
          this.Listar();
        }
      })
    },
    Listar(){
      this.isLoading = true;
      this.service.ListarComFiltro(this.filtro).then(
        res => {
          this.extrato = res.data;
        },
        err => {
          this.$swal('Aviso', err.response.data, 'error')
        }
      ).finally(() => {
        this.isLoading = false;
      });
    },
    PermissaoRestrita(permissao){
      if(this.tipoUsuario == "MASTER"){
        return false;
      }
      if(this.permissoes.find(x => x.menu == permissao)){
        return false;
      }
      else{
        return true;
      }
    },
    UsuarioRestrito(plano){
      if(this.tipoUsuario == "MASTER"){
        return false;
      }
      if(plano.find(x => x == this.empresaPlano)){
        return true;
      }
      else{
        return false;
      }
    }
  },
  created(){
    this.sessionApp = JSON.parse(localStorage.sessionApp);
    const usuarioService = new UsuarioService();
    usuarioService.ListarTudo("Permissoes").then(
      res=>{
        var usuario = res.data.items;
        usuario = usuario.find(x => x.id == this.sessionApp.usuarioId)
        this.permissoes = usuario.permissoes;
      }
    )
  },
  mounted() {

    this.MesReferencia();

    this.sessionApp = JSON.parse(localStorage.sessionApp);
    this.tipoUsuario = this.sessionApp.usuarioNome;

    this.empresaService.ObterPorId(this.sessionApp.empresaId).then(
      res=>{
        this.empresaPlano = res.data.plano;
      }
    )

    let bancoService = new BancoService();
    bancoService.Listar().then(
      res => {
        const bancoDireto = res.data.items;
        bancoDireto.forEach(x => {
          if(x.situacao == 'A'){
            this.bancos.push(x);
          }
        });
        this.bancos.unshift({
          id: null,
          codigoNome: "Todos"
        })
      },
      err => {
        this.$swal('Aviso', err.message, 'error');
      }
    );

    let tipoFluxoBancarioEnumService = new TipoFluxoBancarioEnumService();
    tipoFluxoBancarioEnumService.Listar().then(
      res => {
        this.tipos = res.data;
        this.tipos.unshift({
          key: "",
          value: "< TODOS >"
        });
      },
      err => {
        this.$swal('Aviso', err.message, 'error');
      }
    );
  }
}
</script>
